module.exports = __webpack_public_path__ + "img/weloop-logo.0be03b27.png";